// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FactorPredict_wrapper__2L5cG"};